import OrderedServicesDetails from './Services/OrderedServicesDetails'
import PropTypes from 'prop-types'

const ServiceConfigDetails = ({
  record,
  title,
  style,
  onAcceptOrder,
  onRejectOrder,
  isOrderAccepted = false,
  isOrderRejected = false,
  isMyServicesPage = false,
}) => {
  return record.service_name === 'Feasibility Check' ? null : (
    <div style={style}>
      <h2
        style={{
          padding: '10px 20px',
          marginBottom: '30px',
          background: 'whitesmoke',
          borderRadius: '6px',
          color: '#6A6B70',
        }}
      >
        {title}
      </h2>
      <div style={{ paddingLeft: '20px', width: '97%' }}>
        <OrderedServicesDetails
          record={record}
          onAcceptOrder={onAcceptOrder}
          onRejectOrder={onRejectOrder}
          isOrderAccepted={isOrderAccepted}
          isOrderRejected={isOrderRejected}
          isMyServicesPage={isMyServicesPage}
        />
      </div>
    </div>
  )
}

ServiceConfigDetails.propTypes = {
  record: PropTypes.shape({
    service_name: PropTypes.string,
  }).isRequired,
  title: PropTypes.string.isRequired,
  style: PropTypes.object,
  onAcceptOrder: PropTypes.func,
  onRejectOrder: PropTypes.func,
  isOrderAccepted: PropTypes.bool,
  isOrderRejected: PropTypes.bool,
  isMyServicesPage: PropTypes.bool,
}

export default ServiceConfigDetails
